import "./column-components.c66242f5.js";
import "./column-components.b2a20dc1.js";
import {useContext as $l5fDU$useContext} from "react";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $ea7898346bdc1430$exports = {};

$parcel$export($ea7898346bdc1430$exports, "ColumnImage", () => $ea7898346bdc1430$export$2fc53c648b2db8c4);


var $4bJ9d = parcelRequire("4bJ9d");

var $aVUB5 = parcelRequire("aVUB5");
function $ea7898346bdc1430$export$2fc53c648b2db8c4(props) {
    const { src: src, insets: insets = {}, clip: clip = true, ...rest } = props;
    const { pixelHeight: pixelHeight } = (0, $l5fDU$useContext)((0, $aVUB5.ColumnContext));
    let margins = {};
    for(let key in insets)margins["margin" + key[0].toUpperCase() + key.slice(1)] = -insets[key];
    const overflow = clip ? "hidden" : "visible";
    const height = pixelHeight - (margins.marginTop ?? 0) - (margins.marginBottom ?? 0);
    return (0, $4bJ9d.default)("div.column-image", {
        style: {
            overflow: overflow,
            ...rest
        }
    }, [
        (0, $4bJ9d.default)("img", {
            src: src,
            style: {
                height: height,
                ...margins
            }
        })
    ]);
}


export {$ea7898346bdc1430$export$2fc53c648b2db8c4 as ColumnImage};
//# sourceMappingURL=column-components.3d7ba1c9.js.map
